module.exports = __webpack_public_path__ + "static/media/download.94001022.svg";